import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import httpErrorCodes from '../common/http_error_codes';
import { AuthService } from '../services/auth.service';

@Injectable()
export default class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toastService: ToasterService,
    private translateService: TranslateService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getAuthToken();
    let headers = new HttpHeaders().set('Content-Type', 'application/json');

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    const clonedRequest = request.clone({ headers });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        this.toastService.clearToasts();

        if (error.status === httpErrorCodes.NOT_FOUND) {
          return throwError(() => error);
        }

        if (
          error.status === httpErrorCodes.UNAUTHORIZED ||
          error.status === httpErrorCodes.TOKEN_EXPIRED
        ) {
          this.toastService.showErrorToast(this.translateService.instant('COMMON.TAKING_BUDDY'));
          this.authService.logout();
        }

        return throwError(() => error); // Ensure to propagate the error correctly
      }),
    );
  }
}
